export const consetPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_FlickrBadgeWidget',
  componentNameDefault: 'Flickr Gallery',
  companyNameKey: 'CookieConsent_Dataset_Component_FlickrBadgeWidget',
  companyNameDefault: 'Flickr',
};
